import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CriteriaOptionDirective } from './criteriaOption.directive';
import { StickySideBarDirective } from './sticky-side-bar.directive';



@NgModule({
  declarations: [	
      CriteriaOptionDirective,
      StickySideBarDirective
   ],
  imports: [
    CommonModule
  ],
  exports:[
    CriteriaOptionDirective,
    StickySideBarDirective
  ]
})
export class DirectivesModule { }
